import { defineStore } from "pinia";
import {Worker, WorkerApi} from "@/ api/WorkerApi";
import { i18n } from "@/i18n";

export type WorkerStore = {
    worker: Worker | null
}

// Код языка из профиля (Worker.Language) → локаль i18n
const LOCALE_BY_LANGUAGE_CODE: Record<number, string> = { 0: "ru", 1: "en", 2: "vi" };

export const workerStore = defineStore({
    id: 'workerStore',
    state: () => ({
        worker: null,
    } as WorkerStore),
    actions: {
        // applyLocale = false, когда язык уже задан явно через ?lang= в URL —
        // такой выбор профиль перебивать не должен.
        async getWorkerProfile(applyLocale = true) {
            try {
                this.worker = await WorkerApi.getWorkerProfile()
                if (applyLocale) {
                    this.applyProfileLocale()
                }
            } catch (e) {
                console.error(e)
            }
        },
        applyProfileLocale() {
            if (!this.worker) {
                return
            }
            const locale = LOCALE_BY_LANGUAGE_CODE[this.worker.Language]
            if (locale) {
                // @ts-ignore — legacy-режим vue-i18n: locale присваивается строкой
                i18n.global.locale = locale
                document.documentElement.lang = locale
            }
        },

        async setLanguageFromAngular(language: number) {
            const locale = LOCALE_BY_LANGUAGE_CODE[language]
            if (!locale) {
                // Незнакомый код в i18n не пускаем
                return
            }
            if (String(i18n.global.locale) === locale && this.worker?.Language === language) {
                return
            }
            if (this.worker) {
                this.worker.Language = language
            }
            // @ts-ignore — legacy-режим vue-i18n: locale присваивается строкой
            i18n.global.locale = locale
            document.documentElement.lang = locale
            await this.getWorkerProfile(false)
            if (this.worker && this.worker.Language !== language) {
                this.worker.Language = language
            }
        },
        async setStatus(value: string) {
            await WorkerApi.setStatus(value)
            if (this.worker) {
                this.worker.Status = value
            }
        }
    },
    getters: {
        workerProfile(state): Worker | null {
            return state.worker
        }
    }
})
